import Vue from 'vue';
import axios from 'axios';

export default {
  name: 'RequestChangeMobile',
  components: {
    EmailComp: require('@/components/email.vue').default,
  },
  data: function () {
    return {
      password: '',
      mobile: '',
      otpCode: '',
      completed: false,
      showMsg: false,
      message: '',
      isInComm: false,
      bOTPSent: false,
      currentPhone: { email: '', valid: false, descr: this.$t('activities.cellPhoneNumber') },
    }
  },
  computed: {
    changeEnabled: function () {
      return !this.isInComm && !this.completed;
    },
  },
  created() {
    let sett = this.$store.getters.getProfileDetails;
   
    if (sett && sett.registrationType != 2)
      this.$router.push('/login');
  },
  methods: {
    redirectBack() {
      this.$router.go(-1);
    },
    resendActivationOtpCode() {
      axios.post('/account/ResendActivationOtpCode', { Value: this.activationCode })
        .then(response => {
          if (response.data.data.status == 0) {
            this.$notify({ duration: 10000, group: 'app', text: this.$t('login.OtpCodeSentMessage'), type: '' });
          }
        });
    },
    changeMobile() {
      if (this.mobile == this.currentPhone.email) {
        this.$notify({ duration: 10000, group: 'app', text: this.$t('login.SamePhoneProvided'), type: 'warn' });
        return;
      }

      let temp = this.$store.getters.getProfileDetails;
      if (!this.currentPhone.valid || !temp || !temp.mobileNo.includes(this.currentPhone.email)) {
        this.$notify({ duration: 10000, group: 'app', text: this.$t('login.WrongPhone'), type: 'warn' });
        return;
      }

      
      this.isInComm = true;
      this.$root.$emit('enable_disable_loader', true);
      axios.post('/account/ChangeMobilePhoneNoRequest', { Password: this.password, MobilePhoneNo: this.mobile })
        .then(response => {
          this.isInComm = false;
          if (response.data.data.status == 0) {
            this.message = this.$t('ChangeMobileRequest');
            this.$notify({ duration: 10000, group: 'app', text: this.$t('login.OtpCodeSentMessage'), type: '' });
            this.bOTPSent = true;
          }
          else {
            this.message = response.data.data.text;
            this.$notify({ duration: 10000, group: 'app', text: response.data.data.text, type: 'warn' });
            setTimeout(() => { this.showMsg=false; }, 5000);
          }
          this.$root.$emit('enable_disable_loader', false);
          this.showMsg = true;
        })
        .catch(e => {
          this.message = e.message;
          this.completed = true; this.showMsg = true;
          this.$notify({ duration: 10000, group: 'app', text: e.message, type: 'warn' });
          this.$root.$emit('enable_disable_loader', false);
        })
    },
    changeMobileComplete() {
      if (this.mobile)
      this.isInComm = true;
      this.$root.$emit('enable_disable_loader', true);
      axios.post('/account/ChangeMobilePhoneNoComplete', { Password: this.password, MobilePhoneNo: this.mobile, OtpCode: this.otpCode })
        .then(response => {
          this.isInComm = false;
          if (response.data.data.status == 0) {
            this.$root.$emit('get_profile_details');
            this.message = this.$t('MobileNoSuccess');
            this.showMessage(this.$t('MobileNoSuccess'), 3)
            this.completed = true;
            setTimeout(() => { this.redirectBack(); }, 5000);
          }
          else {
            this.message = response.data.data.text;
            this.showMessage(this.message, 2)
            setTimeout(() => { this.showMsg = false; }, 5000);
          }
          this.$root.$emit('enable_disable_loader', false);
          this.showMsg = true;
        })
        .catch(e => { this.message = e.message; this.completed = true; this.showMsg = true; this.$root.$emit('enable_disable_loader', false); })
    },
    showMessage(msg, type) {
      this.message = msg;
      if (type === 1)
        this.message += ' ' + this.$t('messages.ProblemPersistsContactSupport');
      this.$notify({ duration: 10000, group: 'app', text: msg, type: type == 1 ? 'warn' : type == 2 ? 'error' : type == 3 ? 'success' : '' }); // title: '',
    },
  },
}
